export class UrlBuilder {
    private readonly baseUrl: string;
    private readonly segments: string[] = [];
    private queryParams: { [key: string]: { toString(): string } } = {};

    constructor(baseURL: string) {
        this.baseUrl = baseURL.endsWith('/')
            ? baseURL.substring(0, baseURL.length - 1)
            : baseURL;
    }

    public addResource(resource: { toString(): string }): this {
        this.segments.push(resource.toString());
        return this;
    }

    public addResources(...resources: { toString(): string }[]): this {
        this.segments.push(...resources.map(x => x.toString()));
        return this;
    }

    public addQueryParam(key: string, value: { toString(): string }): this {
        this.queryParams[key] = value;
        return this;
    }

    public build(): string {
        let url = this.baseUrl;
        this.segments.forEach(segment => {
            url += `/${segment}`;
        });
        if (Object.keys(this.queryParams).length > 0) {
            url += '?';
            Object.keys(this.queryParams).forEach(key => {
                url += `${encodeURIComponent(key)}=${encodeURIComponent(this.queryParams[key].toString())}&`;
            });
            url = url.slice(0, -1);
        }
        return url;
    }
}
